import { Component, EventEmitter, Inject, OnInit, Optional, Output } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { GridModalComponent } from '../../../core/components/grid/grid.decorators';
import { StateDialogContext, TT_STATE_DIALOG } from '../../../modal/state-modal/state-modal.component';

@GridModalComponent('discgrpcust')
@Component({
  selector: 'tt-disc-grp-cust',
  templateUrl: './disc-grp-cust.component.html',
  styleUrls: ['./disc-grp-cust.component.css']
})
export class DiscGrpCustComponent implements OnInit {
    @Output()
    public submit = new EventEmitter<string>();

    discGrpCustKeyno;

    public edit?: Edit;

    public discountGroupCustomerNameButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'discgrpcustlangs', gotoParms: () => this.edit!.discgrpcust_keyno ?? '' }
    ];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, @Inject(TT_STATE_DIALOG) @Optional() stateDialog: StateDialogContext,) {
        this.discGrpCustKeyno = this.stateService.getStateParams()['discgrpcust_keyno'];
        this.initFromDialog(stateDialog);
    }

    private async loadEdit() {
        if (!!this.discGrpCustKeyno) {
            this.edit = (await this.datatask.Post(3119, { discgrpcust_keyno: this.discGrpCustKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3120, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    if (this.stateService.getCurrentName() === 'discgrpcust') {
                        this.stateService.back();
                    } else {
                        this.submit.emit(response.errorcode);
                    }
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        if (this.stateService.getCurrentName() === 'discgrpcust') {
            this.init();
        }
    }

    private async initFromDialog(stateDialog?: StateDialogContext) {
        if (!!stateDialog?.params && 'discgrpcust_keyno' in stateDialog.params) {
            this.edit = stateDialog.params as unknown as Edit;
            stateDialog.setSize({ height: '80vh', width: '80vw' });
            await this.init();
            stateDialog.setHeading('p2_m_discgrpcust', true);
            this.submit.subscribe({ next: (value: string) => stateDialog.close(value) });
        }
    }
}

interface Edit {
    discgrpcust_keyno: string;
    discgrpcust_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('discGrpCust', {
//        templateUrl: 'views/components/views/discGrpCust/discGrpCust.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'discGrpCustService', function ($stateParams, stateService, modalService, translateService, discGrpCustService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let discGrpCustKeyno = $stateParams.discgrpcust_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                discGroupNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('discgrpcustlangs', { discgrpcust_keyno: vm.model.edit.discgrpcust_keyno }) }
//                ],
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await discGrpCustService.getEdit({ discgrpcust_keyno: discGrpCustKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                discGrpCustService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
